import { SiteHeaderType } from 'src/app/layout/models/site-header-type.enum';

export function getVH(siteHeader: SiteHeaderType, includeOffset = true) {
  const topOffset = !includeOffset || siteHeader === SiteHeaderType.Hide ? 0 : 56;
  const vh = (window.innerHeight - topOffset) * 0.01;
  return vh;
}
